export var DomainStatus;
(function (DomainStatus) {
    DomainStatus["Unspecified"] = "Unspecified";
    DomainStatus["Good"] = "Good";
    DomainStatus["Bad"] = "Bad";
    DomainStatus["NoIP"] = "No IP Resolution";
})(DomainStatus || (DomainStatus = {}));
export var DomainResolutionType;
(function (DomainResolutionType) {
    DomainResolutionType["Passed"] = "passed";
    DomainResolutionType["Failed"] = "failed";
    DomainResolutionType["Unknown"] = "unknown";
    DomainResolutionType["Replaced"] = "replaced";
    DomainResolutionType["Expanded"] = "expanded";
})(DomainResolutionType || (DomainResolutionType = {}));
//# sourceMappingURL=Domain.js.map